import elementMatches from "./elementMatches"

const selector = "[data-toggle]"

document.addEventListener("click", (e) => {
  const element = elementMatches(e.target, selector)
  if (element) {
    e.preventDefault()
    e.stopPropagation()

    const toggleSelector = JSON.parse(element.dataset.toggle)
    const toggleElements = document.querySelectorAll(toggleSelector)

    toggleElements.forEach((element) => {
      element.classList.toggle("hidden")
    })
  }
})
